import { useTranslation } from 'react-i18next';
import ImageCard from '../common/imageCard';
import crudeOilVessel from '../assets/img/product-img-crudeoilvessel.png';
import rocksAndSand from '../assets/img/product-img-rocksandsand.png';
import shipBuilding from '../assets/img/product-img-shipbuilding.png';
import shipRental from '../assets/img/product-img-shiprental.png';

const ServicesGrid: React.FC = () => {
  const { t } = useTranslation();

  const serviceImages = [crudeOilVessel, shipBuilding, shipRental, rocksAndSand];
  const translatedServices = t('services.services', { returnObjects: true }) as Array<{
    name: string;
    description: string;
    link: string;
  }>;

  const services = translatedServices.map((service, index) => ({
    imageUrl: serviceImages[index],
    title: service.name,
    learnMoreLink: service.link,
  }));
  return (
    <div className='image-card-container'>
      {services.map((service, index) => (
        <ImageCard
          key={index}
          imageUrl={service.imageUrl}
          title={service.title}
          learnMoreLink={service.learnMoreLink}
        />
      ))}
    </div>
  );
};

export default ServicesGrid;
